import { IKeyValue } from '@fareye/types'
import { HEADERS, get, cancelToken } from '@fareye/utils'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import {
  initReactI18next,
  Translation,
  useTranslation,
  withTranslation
} from 'react-i18next'

export interface ITranslations {
  language: string
  languages: string[]
  translation: IKeyValue<any>
  translations: {
    es: {}
    en: {}
  }
}

export default function usei18n(props: any) {
  const { baseURL } = props.environment
  return i18n
    .use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next as any) // passes i18n down to react-i18next
    .init({
      lng: 'en',
      fallbackLng: 'en',
      // saveMissing: true,
      keySeparator: false, // we do not use keys in form messages.welcome
      backend: {
        loadPath: `${baseURL}/api/v1/translations?locale={{lng}}`,
        // addPath: `${baseURL}/api/v1/translations?locale={{lng}}`,
        crossDomain: true,
        withCredentials: true,
        overrideMimeType: true,
        allowMultiLoading: true,
        customHeaders: {
          authorization: HEADERS().AUTHORIZATION
        },
        request: async function(
          options: any,
          url: any,
          payload: any,
          callback: any
        ) {
          try {
            const isLoggedIn = HEADERS().AUTHORIZATION.split('Bearer ')[1]
            if (isLoggedIn) {
              const source = cancelToken().source()
              const response = await await get(`${url}`, source.token, {
                withCredentials: true
              })
              if (response?.data?.translations) {
                return callback(null, {
                  status: 200,
                  data: response.data?.translations
                })
              } else {
                return callback(null, { status: 200, data: {} })
              }
            } else {
              return callback(null, { status: 200, data: {} })
            }
          } catch (error) {
            console.error(error)
            return callback(null, { status: 200, data: {} })
          }
        },
        parse: (data: any) => JSON.parse(data).translations
      },
      interpolation: {
        escapeValue: false // react already safes from xss
      }
    })
}

export { usei18n, i18n, Translation, useTranslation, withTranslation }
